import { Component, OnInit } from '@angular/core';
import { AlertController, PopoverController } from '@ionic/angular';
import * as _ from 'lodash';

import {
  ActionDropdownType,
  ActionDropdownComponent,
} from 'src/app/components/action-dropdown/action-dropdown.component';
import { Organizer } from 'src/models';
import { ApiService } from 'src/services/api.service';
import { AuthService } from 'src/services/auth.service';
import { MessageService } from 'src/services/message.service';

@Component({
  selector: 'app-admin-account',
  templateUrl: './admin-account.component.html',
  styleUrls: ['./admin-account.component.scss'],
})
export class AdminAccountComponent implements OnInit {
  initialized = false;
  name: string;
  customFields: any[] = [];
  slackEnabled: boolean = false;
  defaultFieldSettings: { [key: string]: { public?: boolean } }[];
  seatsUsed = 0;
  defaultFields = [
    {
      id: 'pronoun',
      title: 'Pronouns',
    },
    {
      id: 'title',
      title: 'Title',
    },
    {
      id: 'department',
      title: 'Department',
    },
    {
      id: 'organization',
      title: 'Organization',
    },
    {
      id: 'division',
      title: 'Division',
    },
    {
      id: 'costCenter',
      title: 'Cost Center',
    },
    {
      id: 'employeeNumber',
      title: 'Employee ID',
    },
    {
      id: 'streetAddress',
      title: 'Street Address',
    },
    {
      id: 'locality',
      title: 'City',
    },
    {
      id: 'region',
      title: 'Region',
    },
    {
      id: 'postalCode',
      title: 'Postal Code',
    },
    {
      id: 'country',
      title: 'Country',
    },
  ];
  isLoadingCheckout = false;

  constructor(
    private msgSrvc: MessageService,
    public authService: AuthService,
    private apiService: ApiService,
    private popoverCtrl: PopoverController,
  ) {}

  async ngOnInit() {
    await this.load();
  }

  async load() {
    const tenant = this.authService.tenant;

    this.slackEnabled = this.authService.integrations.slackEnabled;
    this.name = tenant?.name;

    this.customFields = _.get(tenant, 'users.customProfileFields', []);
    this.defaultFieldSettings = _.defaults(
      _.get(tenant, 'defaultFieldSettings', {}),
      this.defaultFields.reduce((acc, f) => ({ ...acc, [f.id]: {} }), {}),
    );

    if (tenant?.seatsUsed) {
      this.seatsUsed = tenant.seatsUsed;
    }

    this.initialized = true;
  }

  async save() {
    if (!this.initialized || !this.name) {
      return;
    }

    // const updates: any = {
    //   defaultCommunityId: this.defaultCommunityId,
    //   defaultFieldSettings: this.defaultFieldSettings,
    //   permissions: {
    //     canCreateOrganizers: this.canCreateOrganizers,
    //     canViewPeople: this.canViewPeople,
    //   },
    //   users: {
    //     customProfileFields: this.customFields?.map((f) => {
    //       if (!f.id) {
    //         f.id = _.camelCase(f.title);
    //       }

    //       return f;
    //     }),
    //     phoneNumberRequirement: this.phoneNumberRequirement,
    //   },
    // };

    const updates = {
      name: this.name,
    };

    this.initialized = false;

    try {
      await this.authService.updateTenant(updates);

      this.load();
      this.msgSrvc.showBottom('✔︎ Saved');
    } catch (err) {
      this.msgSrvc.showBottom(`Whoops! An error occurred: ${err.message}`);
      this.initialized = true;
    }
  }

  async manageSubscription() {
    this.isLoadingCheckout = true;
    try {
      const session: any = await this.apiService.postPromise('/stripe/generate-billing-session', {});
      window.open(session.url, '_blank');
      this.isLoadingCheckout = false;
    } catch (error) {
      this.isLoadingCheckout = false;
    }
  }

  async showSubscriptionOptions() {
    const CANCEL_SUBSCRIPTION = 'Cancel subscription';
    const ACCOUNT_DELETION = 'Request account deletion';
    const CONTACT_SALES = 'Contact sales';

    const options: ActionDropdownType[] = [
      {
        label: CONTACT_SALES,
      },
    ];

    if (this.authService.accountStatus === 'active') {
      options.push({
        label: CANCEL_SUBSCRIPTION,
      });
    }

    options.push({
      label: ACCOUNT_DELETION,
    });

    const popover = await this.popoverCtrl.create({
      component: ActionDropdownComponent,
      componentProps: {
        options,
        callback: (_idx: number, label: string) => {
          popover.dismiss();

          if (label === CONTACT_SALES) {
            window.open(`mailto:sales@unthread.io`, '_blank');
          } else if (label === CANCEL_SUBSCRIPTION) {
            this.manageSubscription();
          } else if (label === ACCOUNT_DELETION) {
            window.open(
              `mailto:support@unthread.io?subject=Account+Deletion+Request+${this.authService.tenantId}`,
              '_blank',
            );
          }
        },
      },
      showBackdrop: false,
      event,
    });
    popover.present();
  }
}
